(function () {
  if (window.ARRevenueTracking && window.ARRevenueTracking.__initialized) {
    return;
  }

  var LAST_EVENT_KEY = "ar_revenue_tracking_last_event_v1";
  var SESSION_ID_KEY = "ar_revenue_tracking_session_id_v1";
  var lastCheckoutIntentTs = 0;

  function hasAnalyticsConsent() {
    try {
      var customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;
      if (customerPrivacy && typeof customerPrivacy.analyticsProcessingAllowed === "function") {
        return !!customerPrivacy.analyticsProcessingAllowed();
      }
    } catch (error) {
      // Fail closed: if the Customer Privacy API errors, suppress our telemetry.
      return false;
    }

    // Fail closed: if the Customer Privacy API is unavailable, do not assume consent.
    return false;
  }

  function safeString(value, maxLen) {
    if (value == null) return "";
    var output = String(value);
    return output.length > maxLen ? output.slice(0, maxLen) : output;
  }

  function safeNumber(value) {
    var parsed = Number(value);
    if (Number.isFinite(parsed)) return parsed;
    return null;
  }

  function getSessionId() {
    try {
      var existing = window.sessionStorage.getItem(SESSION_ID_KEY);
      if (existing) return existing;

      var sessionId = "ar_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10);
      window.sessionStorage.setItem(SESSION_ID_KEY, sessionId);
      return sessionId;
    } catch (error) {
      return "ar_session_unavailable";
    }
  }

  function createEventId(eventName) {
    return [
      safeString(eventName, 80),
      Date.now().toString(36),
      Math.random().toString(36).slice(2, 8)
    ].join("_");
  }

  function getActiveCurrency() {
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return safeString(window.Shopify.currency.active, 12);
      }
    } catch (error) {}

    return "USD";
  }

  function normalizeDetails(details) {
    var payload = details || {};

    return {
      path: safeString(window.location.pathname, 180),
      pageType: safeString((window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType) || "", 60),
      productId: safeString(payload.productId, 80),
      productHandle: safeString(payload.productHandle, 120),
      variantId: safeString(payload.variantId, 80),
      quantity: safeNumber(payload.quantity),
      termMonths: safeNumber(payload.termMonths),
      priceCents: safeNumber(payload.priceCents),
      monthlyCents: safeNumber(payload.monthlyCents),
      cartItemCount: safeNumber(payload.cartItemCount),
      cartTotalCents: safeNumber(payload.cartTotalCents),
      currency: safeString(payload.currency || getActiveCurrency(), 12),
      zip: safeString(payload.zip, 12),
      trigger: safeString(payload.trigger, 80)
    };
  }

  function toShopifyCustomEventName(eventName) {
    return "ar:" + safeString(eventName, 80);
  }

  function publishShopifyCustomEvent(eventName, details) {
    try {
      var analytics = window.Shopify && window.Shopify.analytics;
      if (!analytics || typeof analytics.publish !== "function") return;
      analytics.publish(toShopifyCustomEventName(eventName), details || {});
    } catch (error) {
      // ignore Shopify publish failures
    }
  }

  function persistLastEvent(entry) {
    try {
      window.sessionStorage.setItem(LAST_EVENT_KEY, JSON.stringify(entry));
    } catch (error) {
      // ignore storage failures
    }
  }

  function pushEvent(eventName, details) {
    if (!hasAnalyticsConsent()) return;

    var normalized = normalizeDetails(details);
    var sessionId = getSessionId();
    var eventId = createEventId(eventName);
    var trackedDetails = Object.assign({}, normalized, {
      sessionId: sessionId,
      eventId: eventId
    });
    var entry = {
      event: eventName,
      ts: new Date().toISOString(),
      details: trackedDetails
    };

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        ar_path: normalized.path,
        ar_page_type: normalized.pageType,
        ar_product_id: normalized.productId,
        ar_product_handle: normalized.productHandle,
        ar_variant_id: normalized.variantId,
        ar_quantity: normalized.quantity,
        ar_term_months: normalized.termMonths,
        ar_price_cents: normalized.priceCents,
        ar_monthly_cents: normalized.monthlyCents,
        ar_cart_item_count: normalized.cartItemCount,
        ar_cart_total_cents: normalized.cartTotalCents,
        ar_currency: normalized.currency,
        ar_zip: normalized.zip,
        ar_trigger: normalized.trigger,
        ar_session_id: sessionId,
        ar_event_id: eventId
      });
    } catch (error) {
      // ignore analytics failures
    }

    try {
      if (window.klaviyo && typeof window.klaviyo.track === "function") {
        window.klaviyo.track(eventName, trackedDetails);
      }
    } catch (error) {
      // ignore klaviyo failures
    }

    publishShopifyCustomEvent(eventName, trackedDetails);

    persistLastEvent(entry);
  }

  function getProductContextFromForm(form) {
    var variantInput = form.querySelector('input[name="id"]');
    var quantityInput = form.querySelector('input[name="quantity"]');
    var productIdAttr = form.getAttribute("data-product-id");
    var productHandleAttr = form.getAttribute("data-product-handle");
    var variantId = variantInput ? variantInput.value : "";
    var quantity = quantityInput ? quantityInput.value : 1;

    var productId = productIdAttr || "";
    var productHandle = productHandleAttr || "";

    if (!productId && window.meta && window.meta.product && window.meta.product.id) {
      productId = String(window.meta.product.id);
    }

    if (!productHandle) {
      var match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
      if (match && match[1]) {
        productHandle = match[1];
      }
    }

    return {
      productId: productId,
      productHandle: productHandle,
      variantId: variantId || "",
      quantity: quantity
    };
  }

  function onProductSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    var isProductForm = form.matches('form[is="product-form"]')
      || ((form.getAttribute("action") || "").indexOf("/cart/add") !== -1 && form.querySelector('input[name="id"]'));

    if (!isProductForm) return;

    var context = getProductContextFromForm(form);

    if (!context.variantId) return;

    pushEvent("ar_add_to_cart_intent", {
      productId: context.productId,
      productHandle: context.productHandle,
      variantId: context.variantId,
      quantity: context.quantity,
      trigger: "product_form_submit"
    });
  }

  function onCheckoutClick(event) {
    var target = event.target && event.target.closest
      ? event.target.closest('button[name="checkout"], input[name="checkout"], [formaction*="/checkout"], a[href*="/checkout"]')
      : null;

    if (!target) return;

    var now = Date.now();
    if (now - lastCheckoutIntentTs < 1000) return;
    lastCheckoutIntentTs = now;

    pushEvent("ar_begin_checkout_intent", {
      trigger: "checkout_click",
      currency: getActiveCurrency()
    });
  }

  function onVariantAdd(event) {
    var detail = event && event.detail ? event.detail : {};
    var items = Array.isArray(detail.items) ? detail.items : [];
    var primaryItem = items.length ? items[0] : {};
    var cart = detail.cart || {};

    pushEvent("ar_add_to_cart_success", {
      productId: primaryItem && primaryItem.product_id != null ? primaryItem.product_id : "",
      productHandle: primaryItem && primaryItem.handle ? primaryItem.handle : "",
      variantId: primaryItem && primaryItem.variant_id != null ? primaryItem.variant_id : "",
      quantity: primaryItem && primaryItem.quantity != null ? primaryItem.quantity : null,
      priceCents: primaryItem && primaryItem.price != null ? primaryItem.price : null,
      cartItemCount: cart && cart.item_count != null ? cart.item_count : null,
      cartTotalCents: cart && cart.total_price != null ? cart.total_price : null,
      currency: cart && cart.currency ? cart.currency : getActiveCurrency(),
      trigger: "variant_add_success"
    });
  }

  function onZipPlannerSubmit(event) {
    var detail = event && event.detail ? event.detail : {};

    pushEvent("ar_zip_planner_submit", {
      zip: detail.zip,
      productId: detail.productId,
      productHandle: detail.productHandle,
      termMonths: detail.termMonths,
      priceCents: detail.priceCents,
      monthlyCents: detail.monthlyCents,
      trigger: "zip_planner"
    });
  }

  function onFinancingTermChange(event) {
    var detail = event && event.detail ? event.detail : {};

    pushEvent("ar_financing_term_change", {
      productId: detail.productId,
      productHandle: detail.productHandle,
      termMonths: detail.termMonths,
      priceCents: detail.priceCents,
      monthlyCents: detail.monthlyCents,
      trigger: "financing_term_toggle"
    });
  }

  document.addEventListener("submit", onProductSubmit, true);
  document.addEventListener("click", onCheckoutClick, true);
  document.addEventListener("variant:add", onVariantAdd, true);
  document.addEventListener("ar:zip-planner-submit", onZipPlannerSubmit, true);
  document.addEventListener("ar:financing-term-change", onFinancingTermChange, true);

  window.ARRevenueTracking = {
    __initialized: true,
    track: pushEvent,
    getLastEvent: function () {
      try {
        var raw = window.sessionStorage.getItem(LAST_EVENT_KEY);
        return raw ? JSON.parse(raw) : null;
      } catch (error) {
        return null;
      }
    }
  };

  pushEvent("ar_revenue_tracking_boot", { trigger: "boot" });
})();
